import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Leaf, Compass, Feather, Heart } from 'lucide-react';
const benefits = [{
  icon: Sparkles,
  text: 'Claridad mental y emocional'
}, {
  icon: Leaf,
  text: 'Sanación energética profunda'
}, {
  icon: Compass,
  text: 'Comprensión de tu vida y tu propósito'
}, {
  icon: Feather,
  text: 'Conexión espiritual auténtica'
}, {
  icon: Heart,
  text: 'Paz interior y equilibrio'
}];
export function Benefits() {
  return <section id="beneficios" className="py-24 relative overflow-hidden" data-id="element-48">
      <div className="absolute inset-0 z-0" data-id="element-49">
        <img src="https://cdn.magicpatterns.com/uploads/fbQ74FsC3s2dT3V3tvS8GU/2.png" alt="" className="w-full h-full object-cover object-right" aria-hidden="true" data-id="element-50" />
        <div className="absolute inset-0 bg-white/[0.68]" data-id="element-51" />
      </div>

      <div className="absolute top-10 left-1/4 w-72 h-72 bg-violet-100/30 rounded-full blur-3xl z-[1]" data-id="element-52" />
      <div className="absolute bottom-10 right-1/4 w-64 h-64 bg-amber-100/20 rounded-full blur-3xl z-[1]" data-id="element-53" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-55">
          <div className="w-full lg:w-1/3" data-id="element-56">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-serif text-stone-900 mb-6 leading-tight" data-id="element-57">
              ¿Qué vas a{' '}
              <span className="text-violet-600 italic" data-id="element-58">conseguir</span>?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-lg text-stone-600 font-light" data-id="element-59">
              Un espacio seguro para liberar bloqueos, encontrar respuestas y
              reconectar con tu esencia más pura.
            </motion.p>
          </div>

          <div className="w-full lg:w-2/3" data-id="element-60">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-61">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="flex items-start gap-4 p-6 rounded-2xl bg-white/80 backdrop-blur-sm shadow-sm border border-stone-100/60 hover:bg-white hover:shadow-md transition-all duration-300" data-id="element-62">
                  <div className="mt-1 text-amber-500" data-id="element-63">
                    <benefit.icon size={24} strokeWidth={1.5} data-id="element-64" />
                  </div>
                  <p className="text-stone-800 font-medium text-lg" data-id="element-65">
                    {benefit.text}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}